/**
 * ActivityLine - Single Activity Item
 * 
 * Minimal: Icon + Action + Timestamp
 * One per line, naturally scannable
 */

import React from 'react';
import './activityline.css';

export default function ActivityLine({ item }) {
  const getIcon = (type) => {
    switch (type) {
      case 'rotation_upload':
        return '📤';
      case 'timecard_upload':
        return '📋';
      case 'rotation_compiled':
        return '⚙️';
      case 'rotation_linked':
        return '🔗';
      case 'pay_calculated':
        return '💰';
      default:
        return '•';
    }
  };

  const getAction = (type, data) => {
    switch (type) {
      case 'rotation_upload':
        return `Rotation ${data.rotation_number} uploaded`;
      case 'timecard_upload':
        return `Timecard uploaded for ${data.bid_period}`;
      case 'rotation_compiled':
        return `Rotation ${data.rotation_number} compiled`;
      case 'rotation_linked':
        return `Linked to timecard`;
      case 'pay_calculated':
        return `Pay calculated: ${data.total_pay}`;
      default:
        return 'Activity recorded';
    }
  };

  const getTimeString = (timestamp) => {
    const date = new Date(timestamp);
    const now = new Date();
    const diff = now - date;

    if (diff < 3600000) {
      const mins = Math.floor(diff / 60000);
      return `${mins}m ago`;
    } else if (diff < 86400000) {
      const hours = Math.floor(diff / 3600000);
      return `${hours}h ago`;
    } else {
      return date.toLocaleDateString();
    }
  };

  return (
    <div className="activity-line">
      <div className="activity-line__icon">{getIcon(item.type)}</div>
      <div className="activity-line__content">
        <div className="activity-line__action">{getAction(item.type, item.data)}</div>
        <div className="activity-line__time">{getTimeString(item.timestamp)}</div>
      </div>
    </div>
  );
}
